export const REACT_APP_API_URL =
  "https://globalparkingservices.com/adminmanager/api/";